export const environment = {
  production: true,
  apiUrl: 'https://api.cma.adfs1.com/api', //uat api url not ui
  adfsUrl: "https://fs.adfs1.com",    //uat
  adfsResetPasswordUrl: "https://adfs.uat.afc.lta.gov.sg/adfs/portal/updatepassword",
}
